import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 16px;
    font-family: sans-serif;
    // &.wf-active {
    //   font-family: Open Sans, Roboto;
    // }
    pre{
      white-space: pre-line;
      word-wrap: break-word;
      text-align: justify;
    }
    body{
      background:#f6f6f6;
    }
    h1, h2, h3, h4, p {
      margin: 0.5em 0;
    }
    a {
      &:visited {
        color: inherit;
      }
    }
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
`;

export default GlobalStyle;
